module.exports = __webpack_public_path__ + "media/images/arrow_up-43f72789569d5c4ffdb7b78d44e0e214.svg";